import React from 'react';
import './AboutUs.css';
import swift from './swift.jpg'
import ertiga from './ertiga.png'
import innova from './innova.jpg'
import cabs from './cabs.png'

const AboutUs = () => {
  return (
    <div className="wg-about-container">
      {/* Hero Section */}
      <section className="wg-hero-section">
        <div className="wg-hero-overlay"></div>
        <div className="wg-hero-content">
          <h1 className="wg-hero-title">Journey With Divine Blessings</h1>
          <p className="wg-hero-subtitle">Waheguru Cabs - Your Trusted Travel Partner</p>
        </div>
      </section>

      {/* Mission Section */}
      <section className="wg-mission-section">
        <div className="wg-section-header">
          <h2 className="wg-section-title">Our Mission</h2>
          <div className="wg-title-underline"></div>
        </div>
        <div className="wg-mission-content">
          <div className="wg-mission-card wg-card-animate">
            <div className="wg-mission-icon">
              <i className="fas fa-hand-holding-heart"></i>
            </div>
            <h3>Service With Devotion</h3>
            <p>We believe in serving our customers with the same devotion as we serve the Divine.</p>
          </div>
          <div className="wg-mission-card wg-card-animate">
            <div className="wg-mission-icon">
              <i className="fas fa-shield-alt"></i>
            </div>
            <h3>Safe & Secure Rides</h3>
            <p>Your safety is our top priority. All our drivers are thoroughly vetted and trained.</p>
          </div>
          <div className="wg-mission-card wg-card-animate">
            <div className="wg-mission-icon">
              <i className="fas fa-rupee-sign"></i>
            </div>
            <h3>Fair Pricing</h3>
            <p>Transparent pricing with no hidden charges. Pay what you see on the app.</p>
          </div>
        </div>
      </section>

      {/* Story Section */}
      <section className="wg-story-section">
        <div className="wg-story-container">
          <div className="wg-story-image">
            <img src={cabs} alt="Waheguru Cabs Founder" />
          </div>
          <div className="wg-story-content">
            <h2 className="wg-story-title">Our Humble Beginnings</h2>
            <div className="wg-story-text">
              <p>Founded in 2015 with just 3 cars, Waheguru Cabs began as a small initiative to provide reliable transportation services to the local gurdwara visitors.</p>
              <p>Today, we operate in 12 cities with a fleet of over 500 vehicles, but our core values remain the same - service, safety, and sincerity.</p>
              <p>Every ride with us is blessed with the divine name of Waheguru, ensuring you travel with peace of mind.</p>
            </div>
            <button className="wg-story-button">Meet Our Team</button>
          </div>
        </div>
      </section>

      {/* Values Section */}
      <section className="wg-values-section">
        <div className="wg-section-header">
          <h2 className="wg-section-title">Our Core Values</h2>
          <div className="wg-title-underline"></div>
        </div>
        <div className="wg-values-container">
          <div className="wg-value-item wg-value-animate">
            <div className="wg-value-number">01</div>
            <h3>Seva (Selfless Service)</h3>
            <p>We treat every ride as an opportunity to serve, not just a business transaction.</p>
          </div>
          <div className="wg-value-item wg-value-animate">
            <div className="wg-value-number">02</div>
            <h3>Satkaar (Respect)</h3>
            <p>Every customer, driver, and team member is treated with utmost respect.</p>
          </div>
          <div className="wg-value-item wg-value-animate">
            <div className="wg-value-number">03</div>
            <h3>Vishwas (Trust)</h3>
            <p>We build relationships based on trust and reliability.</p>
          </div>
          <div className="wg-value-item wg-value-animate">
            <div className="wg-value-number">04</div>
            <h3>Simran (Remembrance)</h3>
            <p>We remember the Divine in all our actions and decisions.</p>
          </div>
        </div>
      </section>

      {/* Fleet Section */}
      <section className="wg-fleet-section">
        <div className="wg-section-header">
          <h2 className="wg-section-title">Our Blessed Fleet</h2>
          <div className="wg-title-underline"></div>
        </div>
        <div className="wg-fleet-container">
          <div className="wg-fleet-carousel">
            <div className="wg-fleet-item">
              <img src={swift} alt="Economy Car" />
              <h3>Waheguru Economy</h3>
              <p>Affordable rides for everyday travel</p>
            </div>
            <div className="wg-fleet-item">
              <img src={ertiga} alt="Premium Car" />
              <h3>Waheguru Premium</h3>
              <p>Luxury travel with divine comfort</p>
            </div>
            <div className="wg-fleet-item">
              <img src={innova} alt="SUV" />
              <h3>Waheguru Family</h3>
              <p>Spacious vehicles for groups</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="wg-cta-section">
        <div className="wg-cta-overlay"></div>
        <div className="wg-cta-content">
          <h2>Ready for a Blessed Journey?</h2>
          <div className="wg-cta-buttons">
            <a href='/contact'><button className="wg-cta-button wg-cta-primary">Book a Ride Now</button></a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AboutUs;